/* author:莫兰;
 *  date:2021/1/12;
 *  explan:产品相关api；
 *  desc:包含活体  商品 洗美服务 医疗服务 寄养服务  住院服务  各种套餐等
 */
import api from "./api.js";
let baseURL2 = process.env.VUE_APP_Url2; //郭雪峰接口 8000；
let baseURL7 = process.env.VUE_APP_Url7; //徐林飞负责 8002
console.log(baseURL2, '111', baseURL7);
export function getWashServiceList(params) {
	return api.post(`${baseURL2}api/product/service/wash/list`, params)
} //洗美服务列表
export function setWashService(params) {
	return api.post(`${baseURL2}api/product/service/wash/update`, params)
} //更新洗美服务
export function getWashServiceDl(params) {
	return api.get(`${baseURL2}api/product/service/wash`, params)
} //获取洗美服务
export function deleteWashService(params) {
	return api.delete(`${baseURL2}api/product/service/wash`, params)
} //删除洗美服务
export function getWashServiceLabelList(params) {
	return api.delete(`${baseURL2}api/product/service/wash`, params)
} //删除洗美服务

// 分类
export function getProductTypeList(params) {
	return api.get(`${baseURL2}api/dict/ProductType/tree`, params)
} //分类列表
export function setProductType(params) {
	return api.post(`${baseURL2}api/dict/ProductType/update`, params)
}
export function getProductTypeDl(params) {
	return api.get(`${baseURL2}api/dict/ProductType/codemodel`, params)
}
export function deleteProductType(params) {
	return api.delete(`${baseURL2}api/dict/ProductType`, params)
}
// 生成商品69码
export function makeCode(params) {
	return api.post(`${baseURL2}api/product/goods/make/code`, params)
}

// 活体
export function getProductPetTypeList(params) {
	return api.post(`${baseURL2}api/product/pet/category/list`, params)
} //分类列表
export function setProductPetType(params) {
	return api.post(`${baseURL2}api/product/pet/category/update`, params)
}
export function getProductPetTypeDl(params) {
	return api.get(`${baseURL2}api/product/pet/category`, params)
}
export function deleteProductPetType(params) {
	return api.delete(`${baseURL2}api/product/pet/category`, params)
}
// 毛色
export function getColorList(params) {
	return api.post(`${baseURL2}api/dict/Color/list`, params)
} //分类列表
// 生活服务
export function getLifeServiceList(params) {
	return api.post(`${baseURL2}api/product/service/life/list`, params)
}
export function setLifeServiceList(params) {
	return api.post(`${baseURL2}api/product/service/life/update`, params)
}
export function getLifeServiceDl(params) {
	return api.get(`${baseURL2}api/product/service/life/editmodel`, params)
}
export function deleteLifeService(params) {
	return api.delete(`${baseURL2}api/product/service/life`, params)
}
// 医疗服务
export function getMedicalServiceList(params) {
	return api.post(`${baseURL2}api/product/service/medical/list`, params)
}
export function setMedicalServiceList(params) {
	return api.post(`${baseURL2}api/product/service/medical/update`, params)
}
export function getMedicalServiceDl(params) {
	return api.get(`${baseURL2}api/product/service/medical`, params)
}
export function deleteMedicalService(params) {
	return api.delete(`${baseURL2}api/product/service/medical`, params)
}
//
export function getServiceDictList(params) {
	return api.post(`${baseURL2}api/service/dict/list`, params)
}

// 药品
export function getProductMedicalList(params) {
	return api.post(`${baseURL2}api/product/medical/list`, params)
}
export function setProductMedical(params) {
	return api.post(`${baseURL2}api/product/medical/update`, params)
}
export function getProductMedicalDl(params) {
	return api.get(`${baseURL2}api/product/medical`, params)
}
export function deleteProductMedical(params) {
	return api.delete(`${baseURL2}api/product/medical`, params)
}

// 品牌列表
export function getBrandInfoList(params) {
	return api.post(`${baseURL2}api/dict/BrandInfo/list`, params)
}
export function getUnitType(params) {
	return api.get(`${baseURL2}api/dict/UnitType/type/list`, params)
} //单位列表
export function getUnitList(params) {
	return api.post(`${baseURL2}api/dict/UnitType/list`, params)
} //单位列表

// 商品
export function getProductGoodsList(params) {
	return api.post(`${baseURL2}api/product/goods/list`, params)
}
export function setProductGoods(params) {
	return api.post(`${baseURL2}api/product/goods/update`, params)
}
export function getProductGoodsDl(params) {
	return api.get(`${baseURL2}api/product/goods/simple`, params)
}
export function deleteProductGoods(params) {
	return api.delete(`${baseURL2}api/product/goods`, params)
}

export function getSeriesList(params) {
	return api.post(`${baseURL2}api/GoodsOtherInfo/SeriesList`, params)
} //添加商品/SeriesList
export function getProductPakageList(params) {
	return api.post(`${baseURL2}api/dict/ProductType/list`, params)
} //分类列表

// 商品套餐
export function getGoodsGroupList(params) {
	return api.post(`${baseURL2}api/product/group/goods/list`, params)
}
export function setGoodsGroup(params) {
	return api.post(`${baseURL2}api/product/group/goods/update`, params)
}
export function getGoodsGroupDl(params) {
	return api.get(`${baseURL2}api/product/group/goods`, params)
}
export function deleteGoodsGroup(params) {
	return api.delete(`${baseURL2}api/product/group/goods`, params)
}

// 疫苗套餐
export function getVaccineGroupList(params) {
	return api.post(`${baseURL2}api/product/group/Vaccine/list`, params)
}
export function setVaccineGroup(params) {
	return api.post(`${baseURL2}api/product/group/Vaccine/update`, params)
}
export function getVaccineGroupDl(params) {
	return api.get(`${baseURL2}api/product/group/Vaccine`, params)
}
export function deleteVaccineGroup(params) {
	return api.delete(`${baseURL2}api/product/group/Vaccine`, params)
}
// 驱虫套餐
export function getDewormingGroupList(params) {
	return api.post(`${baseURL2}api/product/group/Deworming/list`, params)
}
export function setDewormingGroup(params) {
	return api.post(`${baseURL2}api/product/group/Deworming/update`, params)
}
export function getDewormingGroupDl(params) {
	return api.get(`${baseURL2}api/product/group/Deworming`, params)
}
export function deleteDewormingGroup(params) {
	return api.delete(`${baseURL2}api/product/group/Deworming`, params)
}
// 服务套餐
export function getServiceGroupList(params) {
	return api.post(`${baseURL2}api/product/group/service/list`, params)
}
export function setServiceGroup(params) {
	return api.post(`${baseURL2}api/product/group/service/update`, params)
}
export function getServiceGroupDl(params) {
	return api.get(`${baseURL2}api/product/group/service`, params)
}
export function deleteServiceGroup(params) {
	return api.delete(`${baseURL2}api/product/group/service`, params)
}

export function getGoodsSkuList(params) {
	return api.get(`${baseURL2}api/product/goods/sku/list`, params)
}
export function getGoodsSalewayList(params) {
	return api.get(`${baseURL2}api/product/goods/saleway/list`, params)
}
// 虚拟卡套餐
export function getVirtualCardGroupList(params) {
	return api.post(`${baseURL2}api/product/virtual/card/list`, params)
}
export function setVirtualCardGroup(params) {
	return api.post(`${baseURL2}api/product/virtual/card/update`, params)
}
export function getVirtualCardGroupDl(params) {
	return api.get(`${baseURL2}api/product/virtual/card`, params)
}
export function deleteVirtualCardGroup(params) {
	return api.delete(`${baseURL2}api/product/virtual/card`, params)
}
// 虚拟倦套餐
export function getVirtualCouponGroupList(params) {
	return api.post(`${baseURL2}api/product/virtual/coupons/list`, params)
}
export function setVirtualCouponGroup(params) {
	return api.post(`${baseURL2}api/product/virtual/coupons/update`, params)
}
export function getVirtualCouponGroupDl(params) {
	return api.get(`${baseURL2}api/product/virtual/coupons`, params)
}
export function deleteVirtualCouponGroup(params) {
	return api.delete(`${baseURL2}api/product/virtual/coupons`, params)
}

//优惠卷

export function validateCoupon(params) {
	return api.get(`${baseURL7}api/MemberInterest/validateCoupon`, params)
} 
export function getCoupon(params) {
	return api.post(`${baseURL2}api/product/coupons/list`, params)
} //优惠券列表
export function getTypeList(params) {
	return api.post(`${baseURL2}api/product/coupons/order/type/list`, params)
} //订单类目
// /api/product/coupons/update 
export function setCoupon(params) {
	return api.post(`${baseURL7}api/middleware/Coupon/addmj`, params)
} //编辑优惠券 满元减元
export function setCouponRebate(params) {
	return api.post(`${baseURL7}api/middleware/Coupon/addzk`, params)
} //编辑优惠券 满元减元
export function deletCoupon(params) {
	return api.post(`${baseURL7}api/middleware/Coupon/delete`, params)
} //删除优惠券
export function offselfCoupon(params) {
	return api.get(`${baseURL7}api/middleware/Coupon/offshelf`, params)
} //下架优惠券
export function onselfCoupon(params) {
	return api.get(`${baseURL7}api/middleware/Coupon/onshelf`, params)
} //下架优惠券
export function onselfCoupon_new(params) {
	return api.post(`${baseURL2}api/product/coupons/update/status`, params)
} //上下架优惠券1
export function getUseCoupon(params) {
	return api.post(`${baseURL7}api/middleware/Coupon/MList`, params)
} //优惠券使用记录
export function getUseList(params) {
	return api.post(`${baseURL7}api/middleware/Member/List`, params)
} //用户列表
export function sendCoupon(params) {
	return api.post(`${baseURL7}api/middleware/Coupon/ManySendCoupon`, params)
} //赠送优惠券

export function getCouponDl(params) {
	return api.get(`${baseURL7}api/middleware/Coupon/Single`, params)
} //优惠券详情

// 耗材
export function getConsumablesList(params) {
	return api.post(`${baseURL2}api/product/consumableMaterial/list`, params)
}
export function setConsumables(params) {
	return api.post(`${baseURL2}api/product/consumableMaterial/update`, params)
}
export function getConsumablesDl(params) {
	return api.get(`${baseURL2}api/product/consumableMaterial`, params)
}
export function deleteConsumables(params) {
	return api.delete(`${baseURL2}api/product/consumableMaterial`, params)
}
// 员工
export function getStaffList(params) {
	return api.post(`${baseURL2}api/StaffInfo/list`, params)
}
// 关联耗材
export function setRelationCon(params) {
	return api.post(`${baseURL2}api/product/consumableMaterial/relation/update`, params)
}
export function getRelationConDl(params) {
	return api.get(`${baseURL2}api/product/consumableMaterial/relation`, params)
}
export function getStartList(params) {
	return api.post(`${baseURL2}api/dict/common/list`, params)
} //活体星级列表
export function setStartPrice(params) {
	return api.post(`${baseURL2}api/product/pet/category/update/price`, params)
} //设置活体星级价格
export function exportPet(params) {
	return api.post(`${baseURL2}api/product/pet/category/stock/export`, params)
} //宠物导出
